import React from 'react';
import { Terminal, Sparkles } from 'lucide-react';
import InteractiveTerminal from './InteractiveTerminal';

const TerminalSection = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
      {/* Background Grid */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }} />
      </div>
      
      {/* Animated Scan Lines */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-500 to-transparent animate-scan-line" />
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-500/30 mb-4">
            <Terminal className="w-4 h-4 text-cyan-400" />
            <span className="font-bold text-cyan-400 text-sm">INTERACTIVE TERMINAL</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-2">
            Terminal <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-400">Access</span>
          </h2>
          <p className="text-gray-400 text-sm flex items-center justify-center gap-2">
            <Sparkles className="w-4 h-4" />
            Try typing commands like "help", "about", "skills", or "experience"
            <Sparkles className="w-4 h-4" />
          </p>
        </div>

        {/* Terminal */}
        <div className="max-w-2xl mx-auto" data-testid="terminal-section">
          <InteractiveTerminal />
        </div>

        {/* Quick Commands Hint */}
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          {['help', 'about', 'skills', 'experience', 'certs', 'contact'].map((cmd) => (
            <span 
              key={cmd}
              className="px-3 py-1 bg-gray-800 text-gray-400 text-xs font-mono rounded-full border border-gray-700 hover:border-cyan-500/50 hover:text-cyan-400 transition-colors cursor-default"
            >
              {cmd}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TerminalSection;
